import { defineComponent as _defineComponent } from 'vue'
import { AbTitle, AbDescription, AbSection, AbContainer } from '../../ui';
import getSectionSpacing from '../../../helpers/getSectionSpacing';
import { CdnImg, useCdnImg } from '@webplatform/cdn-image';
import { computed } from 'vue-demi';
import { TextAlign } from '../../../types';

interface Props {
  id?: string;
  title?: string;
  description?: string;
  textAlign?: TextAlign;
  image?: {
    src: string;
    alt?: string;
  };
  bgImage?: {
    src: string;
  };
  spacing?: {
    top?: string;
    bottom?: string;
  };
  plain?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderSectionImage',
  props: {
    id: null,
    title: null,
    description: null,
    textAlign: { default: 'left' },
    image: null,
    bgImage: null,
    spacing: null,
    plain: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { id?: string, title?: string, description?: string, textAlign: TextAlign, image?: {
    src: string;
    alt?: string;
  }, bgImage?: {
    src: string;
  }, spacing?: {
    top?: string;
    bottom?: string;
  }, plain?: boolean };

const DEFAULT_SPACING = { top: 'none', bottom: 'none' };



const actualSpacing = getSectionSpacing(DEFAULT_SPACING, props.spacing);
const { generateUrl } = useCdnImg();
const backgroundImage = computed(() => {
  if (props.bgImage !== undefined && props.bgImage.src !== undefined) {
    if (
      props.bgImage.src.startsWith('/cms') ||
      props.bgImage.src.startsWith('http')
    ) {
      return `url(${generateUrl(props.bgImage.src, {})})`;
    } else {
      return `url(${props.bgImage.src})`;
    }
  }
});

return { __sfc: true,DEFAULT_SPACING, props, actualSpacing, generateUrl, backgroundImage, AbTitle, AbDescription, AbSection, AbContainer, CdnImg }
}

})